<template>
  <div class="showcase">
    <div class="container">
      <img class="image" v-lazy="image" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Showcase",
  props: ["image"]
};
</script>

<style lang="scss" scoped>
.showcase {
  // border: 1px solid red;
  grid-area: showcase;
  padding: 1rem;
}

.container {
  // border: 1px solid blue;
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
}

.image {
  // border: 1px solid green;
  position: absolute;
  height: inherit;
  max-width: 100%;
}
@media screen and (max-width: 1366px) {
  .image {
    position: relative;
    width: 100%;
    height: auto;
  }
}

@media screen and (max-width: 812px) {
  .showcase {
    padding: 0 0 0.5rem 0;
  }
}
</style>
